var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time",
    transform: "translate(-1045 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 30,
    height: 30,
    transform: "translate(1045 325)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-access-time",
    "data-name": "Icon material-access-time",
    d: "M13.989,3A11,11,0,1,0,25,14,10.995,10.995,0,0,0,13.989,3ZM14,22.8A8.8,8.8,0,1,1,22.8,14,8.8,8.8,0,0,1,14,22.8Zm.55-14.3H12.9v6.6l5.775,3.465.825-1.353-4.95-2.937Z",
    transform: "translate(1046 326)",
    fill: "#13bcd4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.88818b9079c13faf1aee47efb0717b98.svg";
export { ForwardRef as ReactComponent };